import { render, staticRenderFns } from "./categoriesPlaceholder.vue?vue&type=template&id=2fb08fb6&scoped=true&"
import script from "./categoriesPlaceholder.vue?vue&type=script&lang=js&"
export * from "./categoriesPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./categoriesPlaceholder.vue?vue&type=style&index=0&id=2fb08fb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb08fb6",
  null
  
)

export default component.exports